/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:53
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:19
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';

import {
  COMPLETE_LIST,
  COMPLETE_CATEGORIES_LIST,
  COMPLETE_BANNERS_LIST,
  TOGGLE_SERVICE_STATUS_CHANGE_RESULT,
  TOOGLE_CHANGE_STATUS_LOADING,
  SET_RESPONSE_CODE,
  TOOGLE_SERVICES_LIST_LOADING,
  COMPLETE_PACKAGE_USAGE,
  TOOGLE_GET_USAGE_LOADING,
  SET_SERVICE_STATUS_CONFIRMATION_REQUIRED,
  CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED,
  SET_SELECTED_CATEGORY,
} from './mutation-types';

export default {

  getCachedQuery({ commit }, url) {
    if (window.promises === undefined) {
      window.promises = {};
    }
    if (window.promises[url] === undefined) {
      window.promises[url] = API.get(url);
      const deletePromise = () => {
        if (window.promises !== undefined) {
          window.promises[url] = undefined;
        }
      };
      window.promises[url].catch(deletePromise).then(() => {
        setTimeout(deletePromise, 120000);
      });
      return window.promises[url];
    }
    return window.promises[url];
  },
  async getServicesList({ commit }) {
    let status = 200;
    commit(SET_RESPONSE_CODE, { status });
    try {
      commit(TOOGLE_SERVICES_LIST_LOADING);

      const servicesCallback = this._actions.getCachedQuery[0](`${API_URL}/services`);
      const result = await servicesCallback;

      const list = result.data.services;
      const categories = result.data.categories;
      const banners = result.data.banners;

      commit(COMPLETE_LIST, { list });
      commit(COMPLETE_CATEGORIES_LIST, { categories });
      commit(COMPLETE_BANNERS_LIST, { banners });

      commit(SET_RESPONSE_CODE, { status });
    } catch (error) {
      status = 500;
      commit(SET_RESPONSE_CODE, { status });
    }
    commit(TOOGLE_SERVICES_LIST_LOADING);
    commit(CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED);
  },
  async changeStatus({ commit, dispatch }, data) {
    let result = null;
    try {
      commit(TOOGLE_CHANGE_STATUS_LOADING);
      window.promises = undefined;
      result = await API.patch(`${API_URL}/service/changeStatus`, { ...data });
      const status = result.status;
      commit(SET_RESPONSE_CODE, { status });
      if (result.data.sms_confirmation_required) {
        commit(SET_SERVICE_STATUS_CONFIRMATION_REQUIRED);
      } else {
        let enabled = result.data.enabled;
        let incorrectCode = result.data.incorrect_code;
        let success = result.data.message === 'success';
        commit(TOGGLE_SERVICE_STATUS_CHANGE_RESULT, { enabled, incorrectCode, success });
        if (!incorrectCode) {
          dispatch('getServicesList');
        }
      }
    } catch (error) {
      const status = 500;
      commit(SET_RESPONSE_CODE, { status });
    }
    commit(TOOGLE_CHANGE_STATUS_LOADING);
    return result;
  },
  async getPackageUsage({ commit }, params) {
    let result = null;
    let packageUsage = false;
    try {
      commit(TOOGLE_GET_USAGE_LOADING);
      if (params instanceof Array) {
        let results = await Promise.all(params.map(param => API.get(`${API_URL}/package/usage`, { params: param })));
        packageUsage = results.map(aresult => aresult.data.data);
        result = results[0];
      } else {
        result = (await API.get(`${API_URL}/package/usage`, { params }));
        packageUsage = result.data.data;
      }
      const status = result.status;
      commit(SET_RESPONSE_CODE, { status });
      commit(COMPLETE_PACKAGE_USAGE, { packageUsage });
    } catch (error) {
      const status = error.response.status;
      commit(SET_RESPONSE_CODE, { status });
    }
    commit(TOOGLE_GET_USAGE_LOADING);
    return packageUsage;
  },
  clearPackageUsage({ commit }) {
    commit(COMPLETE_PACKAGE_USAGE, { packageUsage: [] });
  },
  selectCategory({ commit }, category) {
    commit(SET_SELECTED_CATEGORY, category);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Services/actions.js